import React from 'react';

const KeuanganSection = () => {
  const financialData = {
    saldo: 125000000,
    pemasukan: [
      { sumber: 'Penjualan Produk', persentase: 60, color: 'bg-green-500' },
      { sumber: 'Jasa Sewa', persentase: 25, color: 'bg-blue-500' },
      { sumber: 'Investasi', persentase: 15, color: 'bg-purple-500' }
    ],
    highlights: [
      { label: 'Transparansi 100%', icon: '🔍' },
      { label: 'Laporan Real-time', icon: '📈' },
      { label: 'Audit Berkala', icon: '✅' }
    ]
  };

  const formatRupiah = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  };

  return (
    <section id="keuangan" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Transparansi Keuangan
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Kelola keuangan BUMDES dengan sistem yang terbuka dan dapat dipertanggungjawabkan
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Saldo Card */}
          <div className="bg-gradient-to-br from-primary to-blue-600 rounded-2xl p-8 text-white shadow-xl">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold">Saldo BUMDES</h3>
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                <span className="text-xl">💰</span>
              </div>
            </div>
            <div className="text-3xl md:text-4xl font-bold mb-2">
              {formatRupiah(financialData.saldo)}
            </div>
            <p className="text-blue-100">Update per 15 Januari 2024</p>
            
            <div className="mt-8 grid grid-cols-3 gap-4 text-center">
              <div className="bg-white bg-opacity-20 rounded-lg p-3">
                <div className="text-sm opacity-90">Pemasukan</div>
                <div className="font-semibold">+62%</div>
              </div>
              <div className="bg-white bg-opacity-20 rounded-lg p-3">
                <div className="text-sm opacity-90">Pengeluaran</div>
                <div className="font-semibold">-38%</div>
              </div>
              <div className="bg-white bg-opacity-20 rounded-lg p-3">
                <div className="text-sm opacity-90">Growth</div>
                <div className="font-semibold">+24%</div>
              </div>
            </div>
          </div>

          {/* Sumber Pemasukan */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Sumber Pemasukan</h3>
            
            <div className="space-y-6">
              {financialData.pemasukan.map((item, index) => (
                <div key={index}>
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium text-gray-700">{item.sumber}</span>
                    <span className="text-sm font-semibold text-gray-600">{item.persentase}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div 
                      className={`${item.color} h-3 rounded-full transition-all duration-1000`}
                      style={{ width: `${item.persentase}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            {/* Highlights */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {financialData.highlights.map((highlight, index) => (
                  <div key={index} className="text-center">
                    <div className="text-2xl mb-2">{highlight.icon}</div>
                    <div className="text-sm font-medium text-gray-700">{highlight.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ingin Melihat Detail Lebih Lanjut?
            </h3>
            <p className="text-gray-600 mb-6">
              Akses laporan keuangan lengkap dengan login ke sistem BUMDES
            </p>
            <a
              href="#login"
              className="bg-primary text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors duration-200 inline-block"
            >
              Login untuk Akses Detail
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeuanganSection;